/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoRarIcon16Solid = forwardRef('GovKoRarIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.221.011a.228.228 0 0 0-.21.21c-.196 2.124 1.654 3.97 3.768 3.768a.228.228 0 0 0 .21-.21C8.175 1.644 6.309-.193 4.221.011Z" }),
        React.createElement("path", { d: "M3.873 8.317a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25Z" }),
        React.createElement("path", { d: "M9.625 6.692a1.625 1.625 0 1 1-3.25 0 1.625 1.625 0 0 1 3.25 0Z" }),
        React.createElement("path", { d: "M9.625 13.808a1.625 1.625 0 1 1-3.25 0 1.625 1.625 0 0 1 3.25 0Z" }),
        React.createElement("path", { d: "M13.752 6.692a1.625 1.625 0 1 1-3.25 0 1.625 1.625 0 0 1 3.25 0Z" }),
        React.createElement("path", { d: "M5.936 11.875a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25Z" }),
        React.createElement("path", { d: "M11.688 10.25a1.625 1.625 0 1 1-3.25 0 1.625 1.625 0 0 1 3.25 0Z" })));
});
